import Hero from './components/Hero';
import Solutions from './components/Solutions';
import Benefits from './components/Benefits';
import ProductSuite from './components/ProductSuite';
import Testimonials from './components/Testimonials';
import Services from './components/Services';
import Security from './components/Security';
import TrustPricing from './components/TrustPricing';
import Resources from './components/Resources';
import FAQ from './components/FAQ';
import CTASection from './components/CTASection';

export default function Home() {
  // Header and footer come from pages/frontend/masterLayout.
  return (
    <>
      <Hero />
      <Solutions />
      <Benefits />
      <ProductSuite />
      <Testimonials />
      <Services />
      <Security />
      <TrustPricing />
      <Resources />
      <FAQ />
      <CTASection />
    </>
  );
}
